<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ihjdak/tc-custom/cover.jpg?1645577577989?1706297157147" alt="This image is the cover for the book Oilfield Processing of Petroleum"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oilfield Processing of Petroleum
      </h1>
      <p class="bookDescription body article font2">
        <p>This book describes oilfield processing and handling of natural gas in a direct, easy-to-follow format. Process descriptions, design methods, operating procedures and troubleshooting are covered in detail. This hands-on reference will be useful to field practitioners and is an ideal training text. Petroleum engineers will gain a better understanding of surface operations between the wellhead and the point of custody transfer or transport from the production facilities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francis Manning, Richard Thompson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e767f946